import React, { useState, useEffect } from 'react';

const DayCountdown = ({ targetDate, status , role}) => { 
    const setDateToMidnight = (date) => {
        const newDate = new Date(date);
        newDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to 0 (midnight)
        return newDate;
    };
    // let timeLeft = {};

    const calculateTimeLeft = () => {
        // const difference = +new Date(targetDate) - +new Date();

        const from = setDateToMidnight(targetDate);
        const to = new Date();
        let difference = +from - +to;
        if(role === 'VENDOR'){
            if (status === 'Round_2_Completed' || status === 'RFQ Expired' || status === 'Cancelled') {
                difference = 0;
            }
        }else{
            if (status === 'Round_2_Completed'  || status === 'Cancelled') {
                difference = 0;
            }
        }
        
        let timeLeft = {};

        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        } else {
            timeLeft = {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            };
        }

        return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, [targetDate]);

    const timerComponents = [];

    Object.keys(timeLeft).forEach(interval => {
        // console.log('timeLeft[interval]timeLeft[interval]', timeLeft[interval]);
        // if (!timeLeft[interval]) {
        //     return;
        // }

        timerComponents.push(
            <div class="timer-box" key={interval}>
                <div class="timer-number">{timeLeft[interval]}</div>
                <div class="timer-text">{interval}</div>
            </div>
            // <span key={interval}>
            //     {timeLeft[interval]} {interval}{" "}
            // </span>
        );
    });

    return (
        <div class="timer-container">
            <div class="timer-label">Timer</div>
            {/* {console.log(timerComponents)} */}
            {timerComponents.length ? timerComponents : <span>Time's up!</span>}
        </div>
    );
};

export default DayCountdown;